import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 21 21",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18.0314 9.51242L18.025 10.2484C18.0089 11.9735 17.4357 13.6471 16.3907 15.0198C15.3458 16.3924 13.8851 17.3905 12.2266 17.8652C10.568 18.3399 8.80046 18.2657 7.18751 17.6538C5.57455 17.0418 4.20263 15.9249 3.27634 14.4695C2.35005 13.0141 1.91903 11.2983 2.04755 9.57799C2.17608 7.85764 2.85727 6.22494 3.98953 4.92336C5.12179 3.62179 6.64445 2.7211 8.33042 2.35561C10.0164 1.99012 11.7754 2.17942 13.345 2.89527M18.0809 3.84406L10.0113 11.7819L7.63231 9.36108",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgCheck;
